module.exports = __webpack_public_path__ + "img/reference.d4ac91c7.svg";